import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { ServiceCRUD } from '../../../shared/crud/ServiceCRUD';
import { environment } from '../../../../environments/environment';

@Injectable()
export class VeiculoVendidoDetalhadoService extends ServiceCRUD {
  private baseUrlService: string;

  constructor(public httpClient: HttpClient, router: Router) {
    super(httpClient, router);
    this.baseUrlService = environment.URL_API;
  }

  protected getURL(): string {
    return `${this.baseUrlService}/veiculo/vendido_detalhado`;
  }

  public getDados(
    numero_nfe?: any,
    serie?: any,
    id_dealer?: any,
    numero?: any,
    nome?: any,
    cpf?: any,
    nfe_chave?: any,
    logradouro?: any,
    cep?: any,
    cidade?: any,
    estado?: any,
    numero_nota?: any, filter?: any): Observable<any> {
    return this.httpClient.get<any>(`${this.baseUrlService + '/veiculo/vendido_detalhado/' + numero_nfe.toString() + "/" + serie.toString() + "/" + id_dealer.toString()}`, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': JSON.parse(sessionStorage.getItem('currentUser')).token
      }),
      params: new HttpParams()
      // .set('numero', numero.toString())
      // .set('nome', nome.toString())
      // .set('cpf', cpf.toString())
      // .set('nfe_chave', nfe_chave.toString())
      // .set('logradouro', logradouro.toString())
      // .set('cep', cep.toString())
      // .set('cidade', cidade.toString())
      // .set('estado', estado.toString())
      // .set('numero_nota', numero_nota.toString())
    });
  }

}
